import { Tab } from '@sbzen/re-cron'
import { useField } from 'formik'
import { useEffect, useState } from 'react'

export type CronInputTab = Tab.DAY | Tab.HOURS | Tab.MINUTES | Tab.MONTH | 'ADVANCED'

export const CronInputTabOptions: Array<{ label: string; value: CronInputTab }> = [
  {
    label: 'Minutes',
    value: Tab.MINUTES,
  },
  {
    label: 'Hours',
    value: Tab.HOURS,
  },
  {
    label: 'Day',
    value: Tab.DAY,
  },
  {
    label: 'Month',
    value: Tab.MONTH,
  },
  {
    label: 'Advanced',
    value: 'ADVANCED',
  },
]

export const useActiveTab = () => {
  return useState(CronInputTabOptions[0])
}

// Fixes value from cron input to be used on the backend
export const fixCronInputValue = (value: string) =>
  value
    ?.replaceAll('?', '*')
    .replaceAll('SUN', '0')
    .replaceAll('MON', '1')
    .replaceAll('TUE', '2')
    .replaceAll('WED', '3')
    .replaceAll('THU', '4')
    .replaceAll('FRI', '5')
    .replaceAll('SAT', '6')
    .replaceAll('JAN', '1')
    .replaceAll('FEB', '2')
    .replaceAll('MAR', '3')
    .replaceAll('APR', '4')
    .replaceAll('MAY', '5')
    .replaceAll('JUN', '6')
    .replaceAll('JUL', '7')
    .replaceAll('AUG', '8')
    .replaceAll('SEP', '9')
    .replaceAll('OCT', '10')
    .replaceAll('NOV', '11')
    .replaceAll('DEC', '12')

// Fixes cron input value to be valid for the backend and updates cron input value when changing cron string in advanced mode
export const useCronInputValues = (name: string) => {
  const [, { value }, { setValue }] = useField(name)
  const [cronValue, setCronValue] = useState(value ?? '')

  useEffect(() => {
    const newValue = fixCronInputValue(cronValue)
    newValue !== value && setValue(newValue)
  }, [cronValue])

  useEffect(() => {
    setCronValue(value)
  }, [value])

  return [cronValue, setCronValue] as const
}
